import React, { useState, useEffect } from 'react';
import { Field } from 'react-final-form';
// import { nonEmptyArray } from '../../util/validators';
import css from './FieldMultiSelect.module.css';
import { ValidationError } from '../../components';
import classNames from 'classnames';
import IconCollection from '../IconCollection/IconCollection';
const FieldMultiSelect = props => {
  const [selectedOptions, setSelectedOptions] = useState();
  const [isSelected, setIsSelected] = useState(false);
  // REACT-SELECT DOESNT PLAY WELL WITH SSR
  // IF NO WINDOW DONT RENDER
  if (typeof window === 'undefined') {
    return null;
  }
  // CONDITIONALLY IMPORT SELECT MODULES
  const { default: Select, components } = require('react-select'); // eslint-disable-line global-require
  const {
    validate,
    name,
    options,
    label,
    className,
    placeholder,
    meta,
    isMulti,
    isSearchable = false,
    isCategorySelect,
    form,
    isRequired,
    disabled,
    defaultValue,
    subCategoryFiltered,
    onChange,
    onRemoveCategory = false,
    bookingForm = false,
    ...rest
  } = props;

  const status =
    isSelected && isRequired && !selectedOptions
      ? css.error
      : selectedOptions && selectedOptions.value !== ''
        ? css.success
        : css.attention;
  const Option = props => (
    <div>
      <components.Option {...props}>
        <label
          className={css.multiselectValueLabel}
          style={{
            color: (props?.isSelected) ? '#fff' : '#000',
          }}
        >
          {props.label}
        </label>
      </components.Option>
    </div>
  );
  // const MultiValue = props => (
  //   <components.MultiValue {...props}>
  //     <span className={css.multiSelectLabel}>{props.data.label}</span>
  //   </components.MultiValue>
  // );
  const renderSelect = typeof window !== 'undefined';

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: '#D8DCE6',
      boxShadow: 'none',
      backgroundColor: '#fff',
      color: '#4a4a4a',
      textAlign: 'left',
      '&:hover': {
        borderColor: '#aaa',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#1A2E4D'
      
        : '#fff',
        '&:hover': {
          backgroundColor: '#1a2e4dde',
          color: '#fff',
        },
      color: state.isSelected ? '#fff' : '#000',
      fontWeight: 'normal',
    }),
  };

  return options && renderSelect ? (
    <Field name={name} validate={validate}>
      {props => {
        const { input, meta } = props;
        // PULLING INPUT ONCHANGE OUT OF OBJECT SO THAT WE CAN IMPLEMENT OUT OWN
        const { onChange, ...rest } = input;
        const { invalid, touched, error } = meta;
        const hasError = touched && invalid && error;
        const hasAnyValue =
          (Array.isArray(input.value) && input.value.length > 0) ||
          (!Array.isArray(input.value) && input.value);

        // Sync selectedOptions with input.value
        useEffect(() => {
          setSelectedOptions(input.value);
        }, [input.value]);

        return (
          <div
            className={classNames(
              className,
              isMulti ? css.multiSelectWrapper : css.singleSelectWrapper
            )}
          >
            {label ? <label className={css.gap}>{label}</label> : null}
            <div
              className={classNames(status, css.placeholderWrapper, hasAnyValue && css.hasValue)}
            >
              <div className={css.placeholder}>{placeholder || 'Select multiple states'}</div>
              <Select
                styles={customStyles}
                closeMenuOnSelect={!isMulti}
                hideSelectedOptions={false}
                isMulti={isMulti}
                components={{ Option }}
                defaultValue={
                  defaultValue && Object.keys(defaultValue).length ? defaultValue : undefined
                }
                options={options}
                isSearchable={isSearchable}
                className={css.multiSelectBox}
                isDisabled={disabled}
                placeholder={''}
                selected={selectedOptions}
                getOptionValue={value => {
                  setIsSelected(true);
                  return value.key || value.label;
                }}
                {...rest}
                onBlur={() => input.onBlur(input.value)}
                onChange={item => {
                  console.debug('Selected item:', item);
                  setSelectedOptions(item);
                  input.onChange(item);

                  if (isCategorySelect && form) {
                    const { parentId, id, subChildId } = item ?? {};
                    if (subChildId) {
                      const parentCat = subCategoryFiltered.find(st => st.id === subChildId);
                      const parentCatId = parentCat?.parentId;
                      if (parentCatId) {
                        form.batch(() => {
                          form.change('category', parentCatId);
                          form.change('subCategory', subChildId);
                          form.change('subSubCategory', id);
                        });
                      }
                    } else if (parentId) {
                      form.batch(() => {
                        form.change('category', parentId);
                        form.change('subCategory', id);
                      });
                    } else {
                      form.change('category', id);
                    }
                  }
                }}
              />
              {/* show values here */}
              <div className={css.multiSelectValueWrapper}>
                {(Array.isArray(selectedOptions) && selectedOptions.length > 0 && !bookingForm)
                  ? selectedOptions.map((opt, idx) => (
                    <div
                      key={opt.value || opt.label || idx}
                      className={`css-1p3m7a8-multiValue ${css.customMultiValue}`}
                    >
                      <span className={css.customMultiValueLabel}>{opt.label}</span>
                      <span
                        className={css.customMultiValueRemove}
                        onClick={() => {
                          const newOptions = [...selectedOptions];
                          const removedOption = newOptions[idx];
                          newOptions.splice(idx, 1);
                          setSelectedOptions(newOptions);
                          input.onChange(newOptions);
                          if (onRemoveCategory) {
                            onRemoveCategory(removedOption);
                          }
                        }}
                        aria-label="Remove"
                      >
                        <IconCollection name="iconClose" />
                      </span>
                    </div>
                  ))
                  : null}
              </div>
              <ValidationError fieldMeta={meta} />
            </div>
          </div>
        );
      }}
    </Field>
  ) : null;
};
export default FieldMultiSelect;
